/* @flow */
import firebase from 'firebase'
import crypto from 'crypto'
import { CANCEL_PAYMENT_URL, MERCHANT_ID } from '../configs/constants'

// Initialize Firebase
const config = {
  apiKey: "AIzaSyA-B0dh_-HoBK5IAp8s0JPbJbwpMiJWVoA",
  authDomain: "intocaerulus.com",
  databaseURL: "https://caerulusvision.firebaseio.com",
  projectId: "caerulusvision",
  storageBucket: "caerulusvision.appspot.com",
  messagingSenderId: "563183089113"
}
const firebaseApp = firebase.initializeApp(config)
const firebaseAuth = firebaseApp.auth()

const spgatewayKey = 'l9cTCK4vYkTq3dhm9WoUsVLCGzTQqaCc' // 'C3me2n1JRTxx8a8riMUgmgTw5WYdD4Wc'
const spgatewayIV = 'yIdYgLLhE1wUOk2f' // 'zx6eGexnBGisCqXu'
export const ezpayKey = 'AGQ5Cg0ZRgbVriU4pVV4aMEWP1Ny7GAO'
export const ezpayIV = 'CAiHPtoEapMYZjoP'

export default class Firebase {
  initAuth() {
    return new Promise((resolve, reject) => {
      const unsub = firebase.auth().onAuthStateChanged(
        user => {
          unsub()
          resolve(user)
        },
        error => reject(error)
      )
    })
  }

  getProvider(provider) {
    switch (provider) {
      case 'facebook':
        return new firebase.auth.FacebookAuthProvider()
      case 'google':
        return new firebase.auth.GoogleAuthProvider()
      default:
        return null
    }
  }

  // fblogin(token) {
  //   const credential = this.getProvider('facebook').credential(token)
  //   return firebaseAuth.signInWithCredential(credential)
  // }

  signup({ email, password }) {
    return firebaseAuth.createUserWithEmailAndPassword(email, password)
  }

  login({ provider, email, password }) {
    const loginProvider = this.getProvider(provider)
    if (loginProvider) {
      return firebaseAuth.signInWithRedirect(loginProvider)
      // yield put({ type: LOGIN_SUCCESS, result })
    } else {
      if (!!email && !!password) {
        return firebaseAuth.signInWithEmailAndPassword(email, password)
      } else {
        return new Promise((resolve, reject) => resolve({ warn: 'Please input Email/Password' }))
        // yield put({ type: LOGIN_FAILURE, error: { message: "Please input Email/Password" } })
      }
    }
  }

  logout() {
    return firebaseAuth.signOut()
  }

  updatePassword(newPassword) {
    return firebaseAuth.updatePassword(newPassword)
  }

  resetPassword(email) {
    return firebaseAuth.sendPasswordResetEmail(email)
  }

  writeDB(path, value) {
    return firebase.database().ref(path).set(value)
  }

  updateDB(path, value) {
    return firebase.database().ref(path).update(value)
  }

  transaction(path, handler, onComplete) {
    return firebase.database().ref(path).transaction(handler, onComplete)
  }

  pushDB(path, value) {
    const newKey = firebase.database().ref(path).push().key
    this.updateDB(path + '/' + newKey, value)
  }

  removeFromDB(path) {
    return firebase.database().ref(path).remove()
  }

  readDBOnce(path) {
    return firebase.database().ref(path).once('value').then(res => res.val())
  }

  readDBwithFilter(path, value, key) {
    return firebase.database().ref(path).equalTo(value, key).then(res => res.val())
  }

  getStorageUrl(url) {
    return firebase.storage().ref().child(url).getDownloadURL()
  }

  on(path, callback) {
    return firebase.database().ref(path).on('value', (snapshot) => {
      callback(snapshot.val())
    })
  }

  off(path) {
    firebase.database().ref(path).off()
  }

}

export const addpadding = (str, blocksize = 32) => {
  const length = str.length
  const pad = blocksize - (length % blocksize)
  return str + String.fromCharCode(pad).repeat(pad)
}

export const payByCreditCard = (timestamp, orderNo, amount, itemDesc, email) => {
  const body = encodeURI(['MerchantID=' + MERCHANT_ID, 'RespondType=JSON', 'TimeStamp=' + timestamp, 'Version=1.4', 'MerchantOrderNo=' + orderNo, 'Amt=' + amount, 'ItemDesc=' + itemDesc, 'Email=' + email, 'LoginType=0', 'CREDIT=1'].join('&'))
  const cipher = crypto.createCipheriv('aes-256-cbc', spgatewayKey, spgatewayIV)
  const encrypted = cipher.update(addpadding(body), 'utf8', 'hex')
  const tosha = ['HashKey=' + spgatewayKey, encrypted, 'HashIV='+spgatewayIV].join('&')
  const hasher = crypto.createHash('sha256')
  const hashed = hasher.update(tosha).digest('hex').toUpperCase()

  return {
    tradeInfo: encrypted,
    tradeSha: hashed,
  }
}

export const cancelPayment = (timestamp, orderNo, amount) => {
  const body = encodeURI(['RespondType=JSON', 'Version=1.0', 'Amt=' + amount, 'MerchantOrderNo=' + orderNo, 'IndexType=1', 'TimeStamp=' + timestamp].join('&'))
  const cipher = crypto.createCipheriv('aes-256-cbc', spgatewayKey, spgatewayIV)
  const encrypted = cipher.update(addpadding(body), 'utf8', 'hex')
  // return encrypted
  let formData = new FormData()
  formData.append('MerchantID_', MERCHANT_ID)
  formData.append('PostData_', encrypted)
  return fetch(CANCEL_PAYMENT_URL, {
    method: 'POST',
    body: formData,
  }).then(response => response.json())
}

export const createInvoice = (timestamp, orderNo, buyer, taxType, amount, carrierType, carrierNum, loveCode, itemDesc) => {
  
}


// WEBPACK FOOTER //
// ./src/libs/api.js